<template>
    <div>
        <TitleImage image="notices" title="Ingresar"/>
        <div class="spacer"></div>
        <div class="col-md-6 col-sm-11 container">
            <h1 class="h2">Ingresar con un usuario</h1>

            <form @submit.prevent="doLogin" class="lead mt-4">
                <div class="form-group">Correo electronico
                    <br>
                    <input type="text" class="form-control" v-model="form.email" placeholder="Ingresá un correo electronico" required> 
                </div>         
                <div class="form-group mt-4"> 
                    <label>Contraseña</label>             
                    <input type="password" class="form-control" v-model="form.password" placeholder="Ingresá la contraseña" required> 
                </div>
                <button type="submit" class="btn btn-primary">Ingresar</button>
            </form>

            <div class="spacer-large"></div>
        </div>

    </div>
</template>

<script>
import TitleImage from '@/components/TitleImage'
export default {
    data(){
        return {
            form: {
                email: '',
                password: ''
            }
        }
    },
    components:{
        TitleImage
    },
    methods:{
        doLogin(){
            this.$store.dispatch('user/doLogin', this.form)
        }
    }

}
</script>